import React from 'react';

// FPS Component
const FPS = ({fps}) => (
  <p className="FPS">fps: {fps}</p>
);

export default FPS;



// WEBPACK FOOTER //
// ./src/views/Planets/FPS.js